//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UMUM from  '../../library/umum.js'








export default {
  data() {
    return {

      form : {
        id : '',
        uraian : '',
        keterangan : '',

        NO_KK : '',
        NIK : '',
        NAMA_LGKP : '',
        TMPT_LHR : '',
        TGL_LHR : '',
        JENIS_KLMIN : '',
        STAT_HBKEL : '',
        STAT_KWN : '',
        AGAMA : '',
        PDDK_AKH : '',
        GOL_DRH : '',
        JENIS_PKRJN : '',
        NAMA_LGKP_IBU : '',
        NAMA_LGKP_AYAH : '',
        NO_PROP : '',
        NO_KAB : '',
        NO_KEC : '',
        NO_KEL : '',
        URAIAN_KEL : '',
        URAIAN_KEC : '',
        URAIAN_AGAMA : '',
        URAIAN_STAT_KWN : '',
        URAIAN_PKRJN : ''
      },
     
      list_data : [],
      list_keluarga : [],

      page_first: 1,
      page_last: 0,
      page_limit : 8,
      cari_value: "",
      cek_load_data : false,


      mdl_add: false,
      mdl_edit: false,
      mdl_hapus : false,
      btn_add: false,
      mdl_view : false,


      UMUM : UMUM,
    }
  },
  methods: {


    getView : function(){
      this.cek_load_data = true
      fetch(this.$store.state.url.URL_PENDUDUK + "view_kk", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              cari_value: this.cari_value,
              page_limit : this.page_limit,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jmlData;
              this.cek_load_data = false
              console.log(res_data);
      });
    },


    addData : function(number) {
      fetch(this.$store.state.url.URL_PENDUDUK + "Add", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
          this.getView();
      });
    },


    editData : function(){
      fetch(this.$store.state.url.URL_PENDUDUK + "editData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView();
      });
    },

    removeData : function(E){
      fetch(this.$store.state.url.URL_PENDUDUK + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : this.form.id})
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView();
      });

    },

    selectData : function(data){

        console.log(data);

        this.form.NO_KK = data.NO_KK ;
        this.form.NIK = data.NIK ;
        this.form.NAMA_LGKP = data.NAMA_LGKP ;
        this.form.TMPT_LHR = data.TMPT_LHR ;
        this.form.TGL_LHR = data.TGL_LHR ;
        this.form.JENIS_KLMIN = data.JENIS_KLMIN ;
        this.form.STAT_HBKEL = data.STAT_HBKEL ;
        this.form.STAT_KWN = data.STAT_KWN ;
        this.form.AGAMA = data.AGAMA ;
        this.form.PDDK_AKH = data.PDDK_AKH ;
        this.form.GOL_DRH = data.GOL_DRH ;
        this.form.JENIS_PKRJN = data.JENIS_PKRJN ;
        this.form.NAMA_LGKP_IBU = data.NAMA_LGKP_IBU ;
        this.form.NAMA_LGKP_AYAH = data.NAMA_LGKP_IBU ;
        this.form.NO_PROP = data.NO_PROP ;
        this.form.NO_KAB = data.NO_KAB ;
        this.form.NO_KEC = data.NO_KEC ;
        this.form.NO_KEL = data.NO_KEL ;
        this.form.URAIAN_KEL = data.URAIAN_KEL ;
        this.form.URAIAN_KEC = data.URAIAN_KEC ;
        this.form.URAIAN_AGAMA = data.URAIAN_AGAMA ;
        this.form.URAIAN_STAT_KWN = data.URAIAN_STAT_KWN ;
        this.form.URAIAN_PKRJN = data.URAIAN_PKRJN ;    
    },

    getList : function(){
      fetch(this.$store.state.url.URL_PENDUDUK + "api_by_kk", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              kk:  this.form.NO_KK,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_keluarga = res_data;
              console.log(res_data);
      });
    },

    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },
        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },


        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        }


    // ====================================== PAGINATE ====================================







  },

  mounted () {
    this.getView();
  },
}
